import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LecturePlayer from '../components/LecturePlayer';
import QuestionModal from '../components/QuestionModal';

const VIDEO = {
    title: 'React Hooks',
    url: 'http://localhost:3000/videoplayback.mp4',
    questions: [
        'What is a hook?',
        'What is a custom hook?',
        'What is a hook?',
        'What is a custom hook?',
    ]
}; 

function Lecture()  {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <div className="relative flex flex-col min-h-screen bg-gradient-to-r from-indigo-50 to-purple-50">

            <nav className=" p-4 flex justify-between items-center">
                <button className="text-black" onClick={() => navigate(-1)}>
                    <p>../</p>
                </button>
                <div className="text-black">{VIDEO.title}</div>
                <button
                    className="text-black"
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                >
                    <i className="fas fa-question"></i>
                </button>
            </nav>
            <div className="flex-1">
                <LecturePlayer videoUrl={VIDEO.url} start={0}/>
            </div>
            {sidebarOpen && (
                <div
                    className="absolute top-0 right-0 h-full w-1/4 bg-white p-4"
                >
                    <h2 className="text-lg mb-4">Questions</h2>
                    <div className="overflow-y-auto">
                        {VIDEO.questions.map((question, index) => (
                            <div key={index}>
                                <p className="text-gray-700">{question}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Lecture;
